import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { CommonService } from '../../../../services/common/common.service';
import { RestService } from '../../../../services/common/rest.service';
import { BanksService } from '../../../../services/common/banks.service';
import { ToasterMessage } from '../../../../../appconfig';
import { UserService } from '../../../../services/common/user.service';
import { ToasterService } from '../../../../services/common/toaster.service';


@Component({
  selector: 'app-bank-add',
  templateUrl: './bankAccount-add.component.html',
  styleUrl: './bankAccount-add.component.scss'
})
export class BankAccountAddComponent {
  // @Output() edituserPanel = new EventEmitter<any>();
  @Output() changeModalStatus = new EventEmitter<any>();

  @Input() currentBank: any;
  @Input() customerData: any;
  bankForm!: FormGroup;
  selectedBankId: any;
  bankList: any = [];
  bankData: any;
  branchName: string = '';
  branchAddress: string = '';
  Submitted = false;
  bankName: string = '';
  currentBankRecord: any;
  showAddBankAccountModal: boolean = false;
  constructor(private commonService: CommonService, private toasterService: ToasterService, private api: RestService, private fb: FormBuilder, private commonApi: RestService, private userService: UserService,
    public bankService: BanksService
  ) {
    //this.customerData.id = 0 ;
    this.getBankDetails();
    //getting the bank account details
    this.bankService.getAccountDetails().subscribe(data => {
      if (data) {
        this.bankForm.controls['accountHolderName'].setValue(data?.accountHolderName);
        this.bankForm.patchValue({
          bankAccountNo: data?.bankAccountNo,
          ifsc: data?.ifsc,
          id: data?.id
        });
        this.branchAddress = data?.branchAddress;
        this.branchName = data?.branchName;
        // this.bankService.isBankAccountExist = true;
      }
    })
  }

  ngOnInit() {
    this.currentBankRecord = this.currentBank?.currentRecord;

    // Initialize selectedBankId from existing bank record (for edit mode)
    if (this.currentBankRecord?.bankId) {
      this.selectedBankId = this.currentBankRecord.bankId;
    } else if (this.currentBankRecord?.bank?.id) {
      // API might return bank as nested object
      this.selectedBankId = this.currentBankRecord.bank.id;
      this.bankName = this.currentBankRecord.bank.bankName;
    }

    this.initiateBankFrom();
  }

  /**
   * initiating bank form
   */
  initiateBankFrom() {
    this.bankForm = this.fb?.group({
      userId: [''],
      bankId: [this.currentBankRecord?.bankId],
      ifsc: [this.currentBankRecord?.ifsc, [Validators.required]],
      bankAccountNo: [this.currentBankRecord?.bankAccountNo, [Validators.required]],
      accountHolderName: [this.currentBankRecord?.accountHolderName, [Validators.required]],
      isPrimary: [this.currentBankRecord?.isPrimary],
      isActive: [this.currentBankRecord?.isActive],
      branchName: [this.currentBankRecord?.branchName],
      branchAddress: [this.currentBankRecord?.branchAddress],
      id: [this.currentBankRecord?.id]
    })
  }
  /**
  * returns the form control after
  */
  get f(): { [key: string]: AbstractControl } {
    return this.bankForm.controls;
  }

  //fetching the bank details by bank ifsc code
  fetchBankDetails() {
    this.bankService.getBankDetailsByIfsc(this.bankForm?.value?.ifsc).subscribe((res: any) => {
      this.branchAddress = res?.address;
      this.branchName = res?.branch;
      this.bankName = res?.bank;
      this.selectedBankId = this.bankList.find((b: any) => b?.bankName.toLowerCase() == this.bankName.toLowerCase())?.id;


    })
  }

  //getting bank details from bank master API to match the bank name
  getBankDetails() {
    this.bankService.getBankDetail().then((res: any) => {
      if (res) {
        this.bankList = res?.result;

      }
      return this.bankList;
    })
  }

  //opening a modal
  openModal(): void {
    this.showAddBankAccountModal = true;
  }

  /**
   * getting bank Id by matching name
   * @param name name is used to findinf the bank ID
   */
  // getBankIdByBankName(name: any) {
  //   this.selectedBankId = this.bankList.find((b: any) => b?.bankName.toLowerCase() == name.toLowerCase())?.id;
  // }

  //submitting the bankaccount data
  onSubmit() {
    this.Submitted = true;
    if (this.bankForm?.invalid) {
      return
    }

    const id = this.currentBankRecord?.id;

    var data = {
      "accountId": this.customerData,
      "bankId": this.selectedBankId || this.currentBankRecord?.bankId || this.currentBankRecord?.bank?.id,
      "ifsc": this.bankForm?.value?.ifsc,
      "branchName": this.currentBankRecord?.branchName ? this.currentBankRecord?.branchName : this.branchName,
      "branchAddress": this.currentBankRecord?.branchAddress ? this.currentBankRecord?.branchAddress : this.branchAddress,
      "bankAccountNo": this.bankForm?.value?.bankAccountNo,
      "accountHolderName": this.bankForm?.value?.accountHolderName,
      "isPrimary": true,
      "isActive": true
    }
    //submitting bankaccount data for edit mode
    if (id > 0) {
      this.userService.updateBankData(id, data).subscribe((res: any) => {
        this.toasterService.showSuccess('Bank Account' + ' ' + ToasterMessage.updateSuccessMessage);
        this.bankData = res;

        // Add bank details to the response before emitting to parent
        this.bankData = {
          ...this.bankData,
          bank: {
            id: this.selectedBankId,
            bankName: this.bankName
          }
        };
        this.bankService.setAccountDetails(data);
        this.branchAddress = '';
        this.branchName = '';
        this.bankForm.reset();
        this.Submitted = false;
        this.closeBankDialogue(true);
      })
    }
    else {
      //submitting bankaccount data for fresh bankaccount
      this.userService.postBankData(data).subscribe((res: any) => {
        this.toasterService.showSuccess('Bank Account' + ' ' + ToasterMessage.successMessage);
        this.bankData = res;

        // Add bank details to the response before emitting to parent
        this.bankData = {
          ...this.bankData,
          bank: {
            id: this.selectedBankId,
            bankName: this.bankName
          }
        };

        this.bankService.setAccountDetails(this.bankData);

        this.bankForm.reset();
        this.closeBankDialogue(true);
      });
    }
  }

  // /**
  //  * Click Close Model Form
  //  */
  closeBankDialogue(isSubmitted: boolean = false) {
    this.changeModalStatus.emit({
      "showaddUpdateModal": false,
      "isSubmitted": isSubmitted,
      "savedBankAccount": this.bankData  // Pass the saved bank account data back
    })
  }
}
